import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { KbvPluginService } from "@/services/kbvPluginService";
import hotIcon from "../assets/hot-icon.svg";
import { absUrl, useSiteOrigin } from "../useSiteOrigin";
import { useDesktop } from "../useDesktop";
import "./hot-insight.css";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

function formatMatchTime(matchTime, format) {
  if (!matchTime) return "";
  return dayjs.unix(Number(matchTime)).tz(TZ).format(format);
}

function HotInsightCard({ item, origin }) {
  const match = item?.match;
  const homeTeam = match?.homeTeam;
  const awayTeam = match?.awayTeam;
  const league = match?.league;
  const isHot = league?.isHot ?? true;
  const handicap = match?.handicapOdds?.[0]?.initialHandicap ?? null;
  const matchTime = match?.matchTime ?? item?.match_time ?? null;
  const dateLabel = formatMatchTime(matchTime, "DD/MM");
  const timeLabel = formatMatchTime(matchTime, "HH:mm");
  const href = absUrl(origin, `/nhan-dinh/${item?.slug || ""}`);

  return (
    <a className="kbv-hot-insight__item" href={href}>
      <div className="kbv-hot-insight__league">
        {league?.logo ? <img src={league.logo} alt="" /> : null}
        <span className="kbv-hot-insight__league-name">{league?.name}</span>
        {isHot ? <span className="kbv-hot-insight__hot">HOT</span> : null}
      </div>

      <div className="kbv-hot-insight__match">
        <div className="kbv-hot-insight__team">
          {homeTeam?.logo ? <img src={homeTeam.logo} alt="" /> : null}
          <span className="kbv-hot-insight__team-name">
            {homeTeam?.nameVi || homeTeam?.name || "-"}
          </span>
        </div>
        <div className="kbv-hot-insight__meta">
          <span className="kbv-hot-insight__date">{dateLabel || "-"}</span>
          <span className="kbv-hot-insight__time">{timeLabel || "-"}</span>
        </div>
        <div className="kbv-hot-insight__team">
          {awayTeam?.logo ? <img src={awayTeam.logo} alt="" /> : null}
          <span className="kbv-hot-insight__team-name">
            {awayTeam?.nameVi || awayTeam?.name || "-"}
          </span>
        </div>
      </div>

      <p className="kbv-hot-insight__excerpt">{item?.excerpt || "Nội dung nhận định"}</p>

      {handicap != null ? (
        <div className="kbv-hot-insight__handicap">
          <span className="kbv-hot-insight__handicap-name">
            {homeTeam?.nameVi || homeTeam?.name}
          </span>
          <span className="kbv-hot-insight__handicap-val">({handicap})</span>
        </div>
      ) : null}
    </a>
  );
}

export default function HotInsightSideBar() {
  const desktop = useDesktop();
  const origin = useSiteOrigin();
  const [insightList, setInsightList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!desktop) return undefined;
    let cancelled = false;
    setLoading(true);
    KbvPluginService.fetchInsightList({
      isHot: true,
      hotTeam: 1,
      limit: 5,
      page: 1,
      status: "prepare",
      fields: "id,title,slug,excerpt,match_time,match",
    })
      .then((list) => {
        if (!cancelled) setInsightList(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setInsightList([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [desktop]);

  if (!desktop) return null;

  return (
    <aside className="kbv-home kbv-hot-insight" aria-label="Hot insights sidebar">
      <div className="kbv-hot-insight__card">
        <div className="kbv-hot-insight__head">
          <img src={hotIcon} alt="" />
          <span className="kbv-hot-insight__title">Nhận định hot</span>
        </div>

        {loading ? (
          <div className="kbv-hot-insight__empty">Đang tải...</div>
        ) : insightList.length === 0 ? (
          <div className="kbv-hot-insight__empty">Chưa có nhận định hot</div>
        ) : (
          <div className="kbv-hot-insight__list">
            {insightList.map((item, index) => (
              <HotInsightCard key={item?.id ?? index} item={item} origin={origin} />
            ))}
            <a className="kbv-hot-insight__more" href={absUrl(origin, "/nhan-dinh?tab=hot")}>
              Xem tất cả
            </a>
          </div>
        )}
      </div>
    </aside>
  );
}
